import instance from "../network/index"; // Import your axios instance

// This function fetches the CSRF cookie and returns a success message or throws an error
export const fetchCsrfCookie = async () => {
    try {
        const baseUrl = process.env.NEXT_PUBLIC_COMMON_BASE_URL; // Fetch base URL from environment variables

        if (!baseUrl) {
            throw new Error('Base URL is not defined in environment variables');
        }

        // Fetch the CSRF cookie from the server using axios
        await instance.get(`${baseUrl}/sanctum/csrf-cookie`, { withCredentials: true });



        // Return success message when CSRF cookie is fetched successfully
        return 'CSRF cookie fetched successfully';

    } catch (error) {
        console.error('Error fetching CSRF cookie:', error.message);
        throw error; // Rethrow error to be handled elsewhere
    }
};
